<template>
  <router-link
    v-if="featureType && featureType.slug"
    :to="{
      name: 'details-type-signalement',
      params: { feature_type_slug: featureType.slug },
    }"
    class="feature-type-title"
    :title="featureType.title"
  >
    <img
      v-if="featureType.geom_type === 'point'"
      class="list-image-type"
      src="@/assets/img/project-detail/geom-point.png"
      alt="Géométrie point"
    />
    <img
      v-if="featureType.geom_type === 'linestring'"
      class="list-image-type"
      src="@/assets/img/project-detail/geom-line.png"
      alt="Géométrie ligne"
    />
    <img
      v-if="featureType.geom_type === 'polygon'"
      class="list-image-type"
      src="@/assets/img/project-detail/geom-polygon.png"
      alt="Géométrie polygone"
    />
    <img
      v-if="featureType.geom_type === 'multipoint'"
      class="list-image-type"
      src="@/assets/img/multimarker.png"
      alt="Géométrie multipoint"
    />
    <img
      v-if="featureType.geom_type === 'multilinestring'"
      class="list-image-type"
      src="@/assets/img/multiline.png"
      alt="Géométrie multiligne"
    />
    <img
      v-if="featureType.geom_type === 'multipolygon'"
      class="list-image-type"
      src="@/assets/img/multipolygon.png"
      alt="Géométrie multipolygone"
    />
    <img
      v-if="featureType.geom_type === 'none'"
      class="list-image-type"
      src="@/assets/img/project-detail/geom-none.png"
      alt="Aucune géométrie"
      title="Aucune géométrie"
    />
    <span class="ellipsis text-[#1BA0FF]">
      {{ featureType.title }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: "FeatureTypeLink",

  props: {
    featureType: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style scoped>
.feature-type-title {
  display: flex;
  align-items: center;
  line-height: 1.5em;
  width: fit-content;
}
.list-image-type {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  object-fit: contain;
}
</style>
